import { alpha } from "@mui/material";

const SUCCESS = {
  lighter: "#E9FCD4",
  light: "#AAF27F",
  main: "#54D62C",
  dark: "#28A745",
  darker: "#08660D",
  contrastText: "#212B36",
};

/* const ERROR = {
  lighter: "#D0F2FF",
  light: "#74CAFF",
  main: "#1890FF",
  dark: "#0C53B7",
  darker: "#04297A",
  contrastText: "#fff",
}; */

const ERROR = {
  lighter: "#FFE7D9",
  light: "#FFA48D",
  main: "#FF4842",
  dark: "#B72136",
  darker: "#7A0C2E",
  contrastText: "#fff",
};

const INFO = {
  main: "#FFC222",
};

export const palette = {
  primary: {
    dark: "#0277AB",
    main: "#012D57",
    main100: alpha("#012D57"),
    main80: alpha("#012D57", 0.8),
    main60: alpha("#012D57", 0.6),
    main40: alpha("#012D57", 0.4),
    main20: alpha("#012D57", 0.2),
    main10: alpha("#012D57", 0.1),
    lightContrast: "#FFFFFF",
    darkContrast: "#000000",
    contrastText: "#FFFFFF",
    TableHeader: "#012D57",
    TableHeader2: "#012D57",
    text: "#424242",
    selectMenu: "#012D57",
    borderASummary: "#EEEEEE",
    mainLyrics: '#FFFFFF'
  },
  secondary: {
    dark: "#3F3F3E",
    main: "#0277AB",
    main100: alpha("#0277AB"),
    main80: alpha("#0277AB", 0.8),
    main60: alpha("#0277AB", 0.6),
    main40: alpha("#0277AB", 0.4),
    main20: alpha("#0277AB", 0.2),
    main10: alpha("#0277AB", 0.1),
    lightContrast: "#FFFFFF",
    darkContrast: "#3F3F3E",
    contrastText: "#FFFFFF",
    warningAlert: "rgba(255, 184, 0, 0.35)",
  },
  success: { ...SUCCESS },
  error: { ...ERROR },
  info: { ...INFO },
  nabvar: {
    main: "#012D57",
  },
  table: {
    main: "#012D57",
    secondary: "#FFB8B8",
  },
  contrastThreshold: 3,
  tonalOffset: 0.2,
};
